/* eslint-disable react/jsx-tag-spacing */ /* for minified SVGs */
import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const UpArrowIcon = ({
  title = 'Up Arrow',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 11 17" {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M10.236 6.315a1.188 1.188 0 00-.006-1.68L5.732.167 1.235 4.634l-.048.05a1.188 1.188 0 00.042 1.63l.05.049c.466.417 1.182.403 1.63-.042l1.635-1.624v10.949l.002.07a1.188 1.188 0 002.375-.07V4.697l1.634 1.624.051.047a1.188 1.188 0 001.63-.053z" />
  </CreateIconComponent>
);

export default UpArrowIcon;
